import {List, ListItem, Box, Drawer, Button} from '@mui/material';
import {CardContent, Typography} from '@mui/material';
import DoubleArrowSharpIcon from '@mui/icons-material/DoubleArrowSharp';
import MenuIcon from '@mui/icons-material/Menu';
import SentimentSatisfiedAltOutlinedIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';
import TagFacesTwoToneIcon from '@mui/icons-material/TagFacesTwoTone';
import SentimentSatisfiedTwoToneIcon from '@mui/icons-material/SentimentSatisfiedTwoTone';
import InsertEmoticonOutlinedIcon from '@mui/icons-material/InsertEmoticonOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import SentimentVerySatisfiedOutlinedIcon from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import * as React from 'react';
import useScreenSize from './ScreenSize';

export default function Portfolio(){
  const screen=useScreenSize();
  const [open, setOpen]=React.useState(false);
  const openSideBar=(isOpen)=>()=>{
      setOpen(isOpen);
  }
  const education=[{
    degree:'B.Tech CSE with Specialization in IOT',
    institute:'Vellore Institute of Technology',
    place:'Vellore',
    duration:'Sep 2021 - Current',
    cgpa: 'CGPA : 9.21',
  },{
    degree:'Higher Secondary Education',
    institute:'Govt Girls Higher Secondary School',
    place:'Tharamangalam, Salem',
    duration:'Jun 2020 - Apr 2021',
    cgpa: 'Percentage : 94.3%',
  },{
    degree:'Secondary Education',
    institute:'Govt Girls Higher Secondary School',
    place:'Tharamangalam, Salem',
    duration:'Jun 2018 - Apr 2019',
    cgpa: 'Percentage : 92.8%',
  }];
  const projects=[{
    name:'E-commerce Web Application using Tailwind CSS & Next JS',
    duration:'Aug 2023 - Nov 2023',
    description:'Developed an E-commerce web application using React.js, Tailwind CSS for a user-friendly interface, and Next.js for efficient page routing. Designed and implemented a comprehensive admin dashboard with sales reports, order management, and user activity tracking. Created user, product, order, and seller management systems with advanced search, filter, and detailed view functionalities, along with a seamless registration and login system. Built detailed product pages, review sections, an intuitive shopping cart, and integrated multiple payment options to streamline the order processing workflow.',
    url:'https://main-site-ecommers.vercel.app/',
  }];
  const experiences=[{
    company:'Renovatio Design Solutions',
    name:'E-commerce Web Application',
    duration:'Aug 2023 - Nov 2023',
    roleStatus:true,
    role:'FrontEnd Developer',
    link:null,
    description:'Developed dynamic and interactive user interfaces for an E-commerce web application. Styled components for a responsive and modern design, ensuring a user-friendly experience.Implemented efficient page routing and server-side rendering to enhance application performance.Designed and implemented an admin dashboard for comprehensive management of sales, orders, and user activities.Created and managed complex systems for users, products, orders, and sellers with advanced functionalities such as search, filters, and multiple payment options.',
  },{
    company:'Google associated with VIT',
    name:'Google Cloud Computing Foundation Program',
    duration:'Aug 2023 - Nov 2023',
    roleStatus:false,
    role:null,
    link:null,
    description:'Gained practical experience with Google Cloud Platform through numerous hands-on labs. Tackled various challenges utilizing Google Clouds comprehensive cloud computing features. Enhanced skills in cloud infrastructure, services, and tools provided by Google. Completed the course through self-directed learning, demonstrating strong initiative and self-motivation.',
  },{
    company:'Collab Junction',
    name:'FrontEnd Internship',
    duration:'June 2024 - Current',
    roleStatus:true,
    role:'FrontEnd Developer',
    link:'https://collabjn.in/',
    description:'Coming soon....',
  }];
  const certificates=[{
    name:'Google Cloud Computing Foundation Program',
    company:'Google with association of VIT',
    basedOn:'self learning',
    url:'https://drive.google.com/file/d/1iGrXuhjyvm4SPQCndvam_4sWFYSUZsk7/view?usp=drivesdk',
  },{
    name:'Creative Thinking:Techniques and Tools for Success',
    company:'Imperial College, London [Coursera]',
    basedOn:'self learning',
    url:'https://coursera.org/share/19e76a748e243c6eace585fe401a5997',
  },{
    name:'Java Basic',
    company:'HackerRank',
    basedOn:'Skill Test',
    url:'https://www.hackerrank.com/certificates/60250f34f9de',
  },{
    name:'SQL Basic',
    company:'HackerRank',
    basedOn:'Skill Test',
    url:'https://www.hackerrank.com/certificates/581de4641231',
  },{
    name:'Problem Solving Basic',
    company:'HackerRank',
    basedOn:'Skill Test',
    url:'https://www.hackerrank.com/certificates/90c6949d3f7f',
  }];
  const codeprofile=[{
    name:'HackerRank',
    url:'https://www.hackerrank.com/profile/ramyasemmalai',
    icon:<InsertEmoticonOutlinedIcon/>,
  },{
    name:'LeetCode',
    url:'https://leetcode.com/u/Ramya_Semmalai/',
    icon:<SentimentSatisfiedAltOutlinedIcon/>,
  },{
    name:'Work@tech',
    url:'https://workat.tech/profile/ramya_semmalai',
    icon:<TagFacesTwoToneIcon/>,
  },{
    name:'CodeChef',
    url:'https://www.codechef.com/users/ramyasemmalai',
    icon:<SentimentSatisfiedTwoToneIcon/>,
  }];
  const contacts=[{
    url:'ramyasemmalai01@gmail.com',
    icon:<MailOutlineOutlinedIcon/>,
  },{
    url:'https://www.linkedin.com/in/ramya-s-0846a7250/',
    icon:'Linkedin',
  },{
    url:'https://github.com/ramyasemmalai',
    icon:'GitHub',
  }];
  const skills=['Java','DSA','OOPS','C','SDLC','Agile Methodology','HTML5','CSS3','React JS'];
  const list=['About','Education','Skills','Project','Experience','Certification','Coding Profile','Get in touch'];
  const drawerList=(
    <Box className="tw-max-h-screen md:tw-bg-gray-dark md:tw-m-5 md:tw-rounded-2xl tw-shadow-inner tw-shadow-fuch-600 lg:hover:tw-scale-105 lg:hover:tw-duration-200 tw-overflow-y-auto">
      <div className="tw-p-4 tw-mx-3 tw-flex tw-justify-center">
        {screen.width>400?<img src="r.JPG" alt='Ramya' className="tw-p-2 hover:tw-scale-105 hover:tw-duration-200 tw-shadow-inner tw-shadow-violet tw-size-48 tw-object-cover tw-rounded-full"/>:<img src="r.JPG" alt='Ramya' className="tw-p-2 hover:tw-scale-105 hover:tw-duration-200 tw-shadow-inner tw-shadow-violet tw-size-40 tw-object-cover tw-rounded-full"/>}
      </div>
      <div className="tw-pb-1 md:tw-text-white tw-ml-8 tw-flex tw-justify-center ">
      <List>
        {list.map((text,index)=>(
          <ListItem key={index}>
            <a href={`#${text}`} className="tw-text-xl tw-font-semibold hover:tw-underline hover:tw-duration-100 hover:tw-text-blue">{text}</a>
          </ListItem>
        ))}
      </List>
      </div>
    </Box>
  );
  return(
    <div className="tw-select-none tw-bg-gradient-to-t tw-from-black tw-via-slate-400 tw-to-gray-dark tw-text-gray-light">
      <div className="tw-visible md:tw-invisible md:tw-w-0 md:tw-h-0 md:tw-m-0 md:tw-p-0 md:tw-size-0">
      <Button onClick={openSideBar(true)}><MenuIcon/></Button>
      <Drawer open={open} onClose={openSideBar(false)}>
      {drawerList}
      </Drawer>
      </div>
      <div className="md:tw-w-full tw-flex tw-flex-col md:tw-flex md:tw-flex-row tw-max-h-screen tw-overflow-y-hidden">
        <div className="lg:tw-p-5 tw-max-h-screen tw-size-0 tw-invisible md:tw-visible md:tw-w-3/5 lg:tw-w-3/6 xl:tw-w-2/5">
          {drawerList}
        </div>
        <div className="md:tw-w-full md:tw-pl-5 tw-m-2 tw-flex tw-flex-col tw-gap-8 tw-overflow-y-auto tw-overflow-x-hidden">
          <div id="About">
          <div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Who am I <SentimentVerySatisfiedOutlinedIcon className="tw-text-green tw-mb-1"/></div>
          <div className="tw-flex tw-justify-center">
          <div className="tw-text-xl tw-font-semibold tw-rounded-t-xl hover:tw-rounded-b-xl hover:tw-shadow-lg hover:tw-shadow-green tw-shadow-inner tw-shadow-green tw-p-5 tw-w-5/6">
          I am a dedicated Frontend Developer with a strong academic background. Awarded a 100% scholarship through the prestigious <abbr title="Support The Advancement of Rural Students" className="tw-font-bold tw-italic">STARS</abbr> scheme at VIT.  I am passionate about translating theoretical knowledge into practical applications and constantly seeking an opportunity to join a dynamic team and contribute to cutting-edge projects. Eager to learn, grow, and become a valuable asset in building innovative solutions for real-world problem and enhance my experience in real-world projects.          </div>
          </div>
          </div>
          <div id="Education"><div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Education <SchoolOutlinedIcon className="tw-text-blue tw-mb-1"/></div>
            <div className="hover:tw-shadow-inner tw-pl-3 md:tw-pl-0 tw-w-full tw-gap-3 md:tw-p-3 tw-flex tw-flex-col tw-text-center md:tw-flex-row tw-flex-wrap lg:tw-flex-nowrap tw-items-center">
              {education.map((obj)=>(
                <div className="tw-w-4/5 lg:tw-basis-1/3 tw-shadow-inner tw-shadow-slate-500 hover:tw-shadow-purple tw-rounded-xl md:hover:tw-scale-110 md:hover:tw-delay-100 md:hover:tw-transition md:hover:tw-duration-300 hover:tw-text-blue">
                 
                  <CardContent>
                  <Typography className="tw-italic tw-text-xl tw-font-semibold">{obj.degree}</Typography>
                  <Typography className="tw-text-violet">{obj.duration}</Typography>
                    <Typography variant="body1" className="tw-text-slate-500">
                     {obj.institute}
                    </Typography>
                    <Typography variant="body2" className="tw-text-gray-light">
                     {obj.place}
                    </Typography>
                    <div className="hover:tw-scale-95 hover:tw-duration-300 tw-m-1 tw-py-1 tw-shadow-sm tw-rounded-full hover:tw-shadow-yellow tw-shadow-yellow-500 tw-italic tw-flex tw-flex-col tw-flex-end tw-font-semibold tw-text-xl">
                      {obj.cgpa}
                    </div>
                  </CardContent>
                </div>
              ))}
            </div>
          </div>
          <div id="Skills"><div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Skills</div>
            <List className="tw-pl-2 md:tw-pl-0 tw-flex tw-flex-col md:tw-flex-row md:tw-flex-wrap tw-items-center tw-gap-3">
            {
              skills.map((skill,index)=>(
                <ListItem key={index} className=" hover:tw-shadow-slate-500 hover:tw-scale-105 hover:tw-delay-100 hover:tw-transition tw-font-semibold tw-w-2/3 tw-text-center tw-inline-block md:tw-basis-1/4 tw-rounded-xl hover:tw-duration-200 hover:tw-text-white tw-shadow-inner hover:tw-shadow-sm tw-shadow-gray-light">
                  {skill}
                </ListItem>
              ))
            }
            </List>
          </div>
          <div id="Project"><div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Project</div>
             <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-3">
               {projects.map((obj)=>(
                <div className="tw-w-5/6 tw-shadow-gray-light tw-shadow-lg hover:tw-shadow-slate-500 md:tw-p-5 tw-rounded-4xl">
                  <CardContent>
                    
                    <Typography className="tw-text-xl">{obj.name}</Typography>
                    <Typography>{obj.duration}</Typography>
                    <br/>
                    <hr/><br/>
                    {screen.width>400?<Typography className="md:tw-w-full md:tw-h-full hover:tw-text-gray-400">{obj.description}<br className="tw-invisible md:tw-visible"/><br className="tw-invisible md:tw-visible"/></Typography>:<></>}
                    <Typography className="tw-flex tw-justify-between"><span className="tw-text-violet hover:tw-text-blue tw-underline">Do you want to see my work?</span><a href={`${obj.url}`} className="hover:tw-text-blue tw-flex tw-gap-2 tw-justify-between tw-items-between hover:tw-scale-75 hover:tw-duration-200"><DoubleArrowSharpIcon/>Tuoch Me!!!</a></Typography>
                  </CardContent>
                </div>
               ))}
             </div>
          </div>
          <div id="Experience"><div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Experience</div>
          <div className="tw-pl-5 tw-flex tw-flex-col tw-gap-3 tw-items-center tw-w-full">
               {experiences.map((obj)=>(
                <div className="tw-w-5/6 tw-shadow-fuch-600 hover:tw-shadow-lg hover:tw-shadow-violet tw-shadow-inner md:tw-p-5 tw-rounded-4xl">
                  <CardContent>
                    <div className="tw-text-center tw-p-2 tw-shadow-inner tw-shadow-gray-light tw-rounded-xl hover:tw-shadow-none">
                    <Typography className="tw-text-3xl">{obj.name}</Typography>
                    <Typography className="tw-text-2xl">{obj.company}</Typography>
                    {
                      obj.roleStatus?<Typography>{obj.role}</Typography>:''
                    }
                    <Typography>{obj.duration}</Typography>
                    </div>
                    {screen.width>400?<><br/><Typography className={`${obj.description.includes("Coming soon")?'tw-text-center tw-text-2xl':''} hover:tw-text-gray-400`}>{obj.description}<br/><br/></Typography></>:<></>}
                    {screen.width<400?<br/>:<></>}
                    { obj.link===null?<div className="tw-size-0"></div>:<a href={`#${obj.link}`} className="tw-pl-5 tw-text-xl hover:tw-text-blue">{obj.link}</a>}
                  </CardContent>
                </div>
               ))}
             </div>
          </div>
          <div id="Certification"><div className="tw-w-full tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Certification</div>
          <div className="tw-text-center tw-flex tw-flex-col tw-items-center tw-gap-3">
            {certificates.map((obj,index)=>(
              <div className={`${index%2===0?(screen.width>400?'tw-rounded-l-full':'tw-rounded-xl'):(screen.width>400?'tw-rounded-r-full':'tw-rounded-xl')} tw-w-5/6 tw-shadow-yellow tw-shadow-inner hover:tw-shadow-yellow-500 hover:tw-scale-x-95 hover:tw-duration-300`}>
                <CardContent>
                  <Typography className="tw-text-2xl">{obj.name}</Typography>
                  <Typography className="tw-text-xl tw-text-slate-500">{obj.company}</Typography>
                  <Typography className="tw-text-gray-400">{obj.basedOn}</Typography>
                  <div className={`tw-px-10 tw-flex tw-justify-center ${index%2===0?'md:tw-justify-end':'md:tw-justify-start'}`}>
                  <a className={`${index%2===0?'hover:tw-text-violet':'hover:tw-text-yellow'} tw-italic tw-text-xl tw-font-semibold tw-text-blue hover:tw-scale-75 hover:tw-duration-200`} href={`${obj.url}`}>
                    {
                      index%2===0?'To see Click me!':'I\'m Here!!'
                    }
                  </a>
                  </div>
                </CardContent>
              </div>
            ))}
          </div>
          </div>
          <div id="Coding Profile"><div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Coding Profile</div>
          <div className="tw-w-full tw-flex tw-gap-3 tw-text-center tw-justify-center tw-items-center tw-flex-wrap">
            {codeprofile.map((obj)=>(
              
               <CardContent className="hover:tw-font-semibold hover:tw-scale-150 hover:tw-duration-300 tw-flex tw-flex-col tw-justify-center tw-items-center tw-size-36 tw-rounded-full tw-shadow-lg tw-shadow-green">
                <Typography className="tw-text-xl">{obj.name}</Typography>
                <a href={obj.url} className="tw-text-blue hover:tw-text-green hover:tw-scale-75 hover:tw-duration-300 tw-italic">It's Me   {obj.icon}</a>
               </CardContent>
             
            ))}
          </div>
          </div>
          <div id="Get in touch"><div className="tw-font-bold tw-text-3xl tw-mb-2 tw-p-2">Contact <ContactMailOutlinedIcon className="tw-text-violet tw-mb-1"/></div>
          <div className="tw-py-2 tw-flex tw-gap-5 tw-justify-center tw-mb-5">
            {contacts.map((obj)=>(
              <a href={obj.url.includes("gmail.com")?`mailto:${obj.url}`:obj.url} className="tw-shadow-inner tw-shadow-violet tw-rounded-xl tw-px-4 tw-py-2 hover:tw-scale-110 hover:tw-duration-300 tw-italic">{obj.icon}</a>
            ))}
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}
